// App & branding configuration

import * as _ from 'lodash';

export default abstract class AppConfiguration {
    /* App configuration settings */
    public static appConfiguration = {
        // IMPORTANT: ENSURE EVERY CONFIGURATION SETTING HAS BOTH A 'development' AND 'production' FIELD VALUES
        // THESE VALUES CONTROL WHICH VALUE TO USE BASED ON ENVIRONMENT (build|development)

        apiBaseUrl: {
            // Configure API base url
            development: '{BASE_URI_NO_PORT}:4002/v1/',
            production: '{BASE_URI_NO_PORT}/v1/',
            staging: '{BASE_URI_NO_PORT}/v1/'
        },

        googleMaps: {
            development: {
                googleMapsApiKey: 'AIzaSyAudjeJ_mnBSfLrgn9wSDi6Hpmv93RySAI',
                googleMapsApiUrl: 'https://maps.google.com/maps/api/staticmap',
                googleMapsLinkUrl: 'https://maps.google.com/maps?q=',
                googleMapsEmbedUrl: 'https://maps.google.com/maps',
            },

            production: {
                googleMapsApiKey: 'AIzaSyAudjeJ_mnBSfLrgn9wSDi6Hpmv93RySAI',
                googleMapsApiUrl: 'https://maps.google.com/maps/api/staticmap',
                googleMapsLinkUrl: 'https://maps.google.com/maps?q=',
                googleMapsEmbedUrl: 'https://maps.google.com/maps',
            },
            staging: {
                googleMapsApiKey: 'AIzaSyAudjeJ_mnBSfLrgn9wSDi6Hpmv93RySAI',
                googleMapsApiUrl: 'https://maps.google.com/maps/api/staticmap',
                googleMapsLinkUrl: 'https://maps.google.com/maps?q=',
                googleMapsEmbedUrl: 'https://maps.google.com/maps',
            },
        },

        auth0: {
            // Auth0 settings
            development: {
                domain: 'complex.auth0.com',
                clientID: 'b5g7BBt4BNt1EyAZv3Nz5JHvLsoGUhkj',
                redirectUri: '{BASE_URI}/login/callback',
                logoutRedirectTo: '{BASE_URI}/',
                audience: 'api',
                responseType: 'token id_token',
                scope: 'openid',
            },

            production: {
                domain: 'complex.auth0.com',
                clientID: 'b5g7BBt4BNt1EyAZv3Nz5JHvLsoGUhkj',
                redirectUri: '{BASE_URI}/login/callback',
                logoutRedirectTo: '{BASE_URI}/',
                audience: 'api',
                responseType: 'token id_token',
                scope: 'openid',
            },

            staging: {
                domain: 'complex.auth0.com',
                clientID: 'b5g7BBt4BNt1EyAZv3Nz5JHvLsoGUhkj',
                redirectUri: '{BASE_URI}/login/callback',
                logoutRedirectTo: '{BASE_URI}/',
                audience: 'api',
                responseType: 'token id_token',
                scope: 'openid',
            }
        },

        moment: {
            // MomentJS settings - Defined/Default Date Format Strings
            development: {
                dateTimeFormat: 'MM/DD/YYYY h:mma',
                shortDateFormat: 'MM/DD/YYYY',
            },

            production: {
                dateTimeFormat: 'MM/DD/YYYY h:mma',
                shortDateFormat: 'MM/DD/YYYY',
            },

            staging: {
                dateTimeFormat: 'MM/DD/YYYY h:mma',
                shortDateFormat: 'MM/DD/YYYY',
            }
        },

        surge: {
            development: {
                projectDomain: 'app.complexsolutionsltd.com', // 20200321 was: 'complex-solutions.surge.sh',
                projectApiHostname: 'complex-solutions-api.herokuapp.com',
            },

            production: {
                projectDomain: 'app.complexsolutionsltd.com', // 20200321 was: 'complex-solutions.surge.sh',
                projectApiHostname: 'complex-solutions-api.herokuapp.com',
            },

            staging: {
                projectDomain: 'staging-app-complex-solutions-e6c0ffefe50f.herokuapp.com', // 20200321 was: 'complex-solutions.surge.sh',
                projectApiHostname: 'staging-complex-solutions-api-c458d930a48e.herokuapp.com',
            }
        },

        inventoryPictures: {
            development: {
                // amazonBucketBaseUrl: 'https://s3.us-east-2.amazonaws.com/ns8-complex-solutions',
                amazonBucketBaseUrl: 'https://s3.us-west-1.amazonaws.com/complex-solutions',
                // cloudinaryFetchBaseUrl: 'https://res.cloudinary.com/complex-solutions/image/fetch/' // 20200313 Previous development cloudinary account
                cloudinaryFetchBaseUrl: 'https://res.cloudinary.com/complex-app/image/fetch/' // 20200313 Current cloudinary account
            },

            production: {
                // amazonBucketBaseUrl: 'https://s3.us-east-2.amazonaws.com/ns8-complex-solutions',
                amazonBucketBaseUrl: 'https://s3.us-west-1.amazonaws.com/complex-solutions',
                // cloudinaryFetchBaseUrl: 'https://res.cloudinary.com/complex-solutions/image/fetch/' // 20200313 Previous development cloudinary account
                cloudinaryFetchBaseUrl: 'https://res.cloudinary.com/complex-app/image/fetch/' // 20200313 Current cloudinary account
            },

            staging: {
                // amazonBucketBaseUrl: 'https://s3.us-east-2.amazonaws.com/ns8-complex-solutions',
                amazonBucketBaseUrl: 'https://s3.us-west-1.amazonaws.com/complex-solutions',
                // cloudinaryFetchBaseUrl: 'https://res.cloudinary.com/complex-solutions/image/fetch/' // 20200313 Previous development cloudinary account
                cloudinaryFetchBaseUrl: 'https://res.cloudinary.com/complex-app/image/fetch/' // 20200313 Current cloudinary account
            }
        },

        support: {
            development: {
                supportEmail: 'help@complexsolutionsltd.com',
            },

            production: {
                supportEmail: 'help@complexsolutionsltd.com',
            },

            staging: {
                supportEmail: 'help@complexsolutionsltd.com',
            }
        },
    };

    public static getGoogleMapsConfiguration() {
        // Return Google Maps Configuration
        return AppConfiguration.getConfigurationValue(AppConfiguration.appConfiguration.googleMaps);
    }

    public static getAuth0Configuration() {
        // Return auth0 configuration
        let config = _.cloneDeep(AppConfiguration.getConfigurationValue(AppConfiguration.appConfiguration.auth0));

        // Transform redirectUri & logoutRedirecTo values
        let re = /{BASE_URI}/gi;

        config.redirectUri = config.redirectUri.replace(re, `${window.location.protocol}//${window.location.host}`);
        config.logoutRedirectTo = config.logoutRedirectTo.replace(re, `${window.location.protocol}//${window.location.host}`);

        return config;
    }

    public static getMomentShortDateFormat(): string {
        // Return momentjs short date format (MM/DD/YYYY)
        const config = AppConfiguration.getConfigurationValue(AppConfiguration.appConfiguration.moment);

        return _.get(config, 'shortDateFormat', 'MM/DD/YYYY');
    }

    public static getMomentDateTimeFormat(): string {
        // Return momentjs date and time format (MM/DD/YYYY h:mma)
        const config = AppConfiguration.getConfigurationValue(AppConfiguration.appConfiguration.moment);

        return _.get(config, 'dateTimeFormat', 'MM/DD/YYYY h:mma');
    }

    public static getSupportEmail() {
        // Return support email address
        let config = _.cloneDeep(AppConfiguration.getConfigurationValue(AppConfiguration.appConfiguration.support));

        return _.get(config, 'supportEmail', '');
    }

    public static getEnvironmentTarget() {
        // Return build environment target (development, staging, production)

        switch (AppConfiguration.getEnvironment()) {
            default:
            case 'development':
                return '';
            case 'production':
                return ('');
        }
    }

    /* Configuration helper functions */
    public static getEnvironment() {
        // Returns environment key of [development|production]
        let result = _.get(process, 'NODE_ENV', 'production');

        if (window.location.hostname.toLowerCase() === 'app.complexsolutionsltd.com'
            || window.location.hostname.toLowerCase() === 'portal.complexsolutionsltd.com'
            || window.location.hostname.toLowerCase() === 'app.appliedreserveanalysis.com'
            || window.location.hostname.toLowerCase() === 'portal.appliedreserveanalysis.com') { // 20200321 was: 'complex-solutions.surge.sh') {
            result = 'production';
        }

        if (window.location.hostname.toLowerCase() === 'localhost' ||
            window.location.hostname.toLowerCase() === '192.168.88.56' ||
            window.location.hostname.toLowerCase() === '10.0.0.147' ||
            window.location.hostname.toLowerCase() === 'webapp.complexsolutionsltd.com') {
            result = 'development';
        }

        if (window.location.hostname.toLowerCase() === 'staging-app-complex-solutions-e6c0ffefe50f.herokuapp.com') {
            result = 'staging';
        }

        return result;
    }

    public static getConfigurationValue(configParent: any) {
        // Returns configuration setting value based on environment (build|development)
        if (!configParent) { return ''; }

        const environment = AppConfiguration.getEnvironment();

        const config = configParent[environment];

        return config;
    }
}



// WEBPACK FOOTER //
// ./src/config/configuration.tsx